<script setup lang="ts">
import { UIChipSelection, UITag } from '@groover-dev/groover-ui'

import type Tag from '~/entities/tag'
import type TagTypeKey from '~/types/tagTypeKey'

type Props = {
  tag: Tag
  i18nkey: TagTypeKey
  selected?: boolean
  readonly?: boolean
  error?: boolean
  small?: boolean
}
type Emits = {
  click: [Tag, boolean]
}

const {
  tag,
  i18nkey,
  selected = false,
  readonly = false,
  error = false,
  small = false,
} = defineProps<Props>()
const emits = defineEmits<Emits>()

function selectTag() {
  emits('click', tag, selected)
}
</script>

<template>
  <UITag
    v-if="readonly"
    :key="`tag-${tag.id}`"
    :text="$t(`tags.${i18nkey}.${tag.name}`)"
    :size="small ? 'sm' : 'base'"
  />
  <UIChipSelection
    v-else
    :key="`chip-${tag.id}`"
    :model-value="selected"
    :text="$t(`tags.${i18nkey}.${tag.name}`)"
    :class="{ 'tw-border-error': error }"
    size="sm"
    @click="selectTag"
  />
</template>
